// extracted by mini-css-extract-plugin
export default {"inlineLoadingWrapper":"styles_inlineLoadingWrapper__+Rkm2","inlineLoading":"styles_inlineLoading__nrX+v"};